import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import {
  FC,
  ReactElement,
  ReactNode,
  UIEvent,
  useEffect,
  useRef,
  useState,
} from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import { ParallaxProvider } from 'react-scroll-parallax'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { useWindowSize } from 'usehooks-ts'
import { Chapter } from 'components/Chapter'
import { content_gesellschaft } from './content_gesellschaft'
import { content_lifestyle } from './content_lifestyle'
import { content_kultur } from './content_kultur'
import { content_wirtschaft } from './content_wirtschaft'
import { content_politik } from './content_politik'
import { content_sport } from './content_sport'
import { content_international } from './content_international'
import stars from '../../assets/stars.svg'
import stars_dm from '../../assets/stars_dm.svg'
import smoothscroll from 'smoothscroll-polyfill'
import menuicon from '../../assets/icn_menu.svg'

window.dataLayer = window.dataLayer || []
const trackEvent = (event_label?: string | number) => {
  if (window.dataLayer)
    window.dataLayer.push({
      event_label,
      ...{
        event: 'Interactions',
        event_action: 'click',
      },
    })
}

smoothscroll.polyfill()
;(window as any).__forceSmoothScrollPolyfill__ = true

const Sections = [
  'Gesellschaft',
  'Politik',
  'Kultur',
  'International',
  'Wirtschaft',
  'Lifestyle',
  'Sport',
]

const Content: {
  [key: string]: {
    title: string
    author: string
    autorBio: string
    content: ReactNode
    link?: number
  }[]
} = {
  gesellschaft: content_gesellschaft,
  politik: content_politik,
  kultur: content_kultur,
  international: content_international,

  wirtschaft: content_wirtschaft,

  lifestyle: content_lifestyle,
  sport: content_sport,
}

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  const part = properties?.part || 'two'
  const [currentSection, setCurrentSection] = useState(0)
  const [vpHeight, setVpHeight] = useState(0)
  const [menuVisible, setMenuVisible] = useState(false)
  const { width } = useWindowSize()
  useEffect(() => {
    const onScroll = (event: Event) => {
      const body = document.body,
        html = document.documentElement,
        max = Math.max(
          body.scrollHeight,
          body.offsetHeight,
          html.clientHeight,
          html.scrollHeight,
          html.offsetHeight
        )
      if (window.scrollY > 1000 && window.scrollY < max - vpHeight - 1200) {
        setMenuVisible(true)
      } else {
        setMenuVisible(false)
      }
    }

    window.addEventListener('scroll', onScroll)

    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [])

  useEffect(() => {
    setVpHeight(window.innerHeight)
  }, [])
  useEffect(() => {}, [vpHeight])

  return (
    <AppContainer className={globalClasses.join(' ')}>
      {part === 'one' && (
        <>
          <Header
            style={{
              minHeight:
                (width < 900 ? vpHeight * 0.75 : vpHeight * 0.75) + 'px',
            }}
          >
            <h1>
              <img src={colorMode === 'dark' ? stars_dm : stars} />
              <div className='big a'>
                25 Fragen,
                <br />
                die uns 2022 bewegt haben
              </div>
              <div className='big c'>
                Sind die Jungen arbeitsfaul? Ist die Pandemie vorbei? Dürfen
                Weisse Dreadlocks tragen? Antworten auf die prägenden
                Diskussionen des vergangenen Jahres.
              </div>
            </h1>
            <img
              src={require('../../assets/header' +
                (colorMode === 'dark' ? '_dm' : '') +
                '.jpg')}
            />
          </Header>
        </>
      )}

      {part === 'two' && (
        <>
          {menuVisible && width > 1000 && (
            <SideMenu>
              <div className='sidecontainer'>
                {Sections.map((section, r) => {
                  return (
                    <MenuElement
                      key={'menuelement_' + r}
                      onClick={() => {
                        trackEvent('chapternav_desk_selected_' + section)
                        let w = window as any
                        w.menucontent[section.toLowerCase()].scrollIntoView({
                          behavior: 'smooth',
                          block: 'start',
                        })
                      }}
                      style={{
                        fontWeight: currentSection === r ? 'bold' : 'normal',
                      }}
                    >
                      {section}
                    </MenuElement>
                  )
                })}
              </div>
            </SideMenu>
          )}
          {menuVisible && width < 1001 && (
            <BottomMenu current={currentSection} entries={Sections} />
          )}
          <TextWidth>
            <Chapters>
              <div className='title'>Wählen Sie ein Kapitel</div>
              {Sections.map((section, r) => {
                return (
                  <TopMenuElement
                    left={r % 2 === 0}
                    key={'menuelement_' + r}
                    onClick={() => {
                      trackEvent('chapternav_top_selected_' + section)
                      let w = window as any
                      w.menucontent[section.toLowerCase()].scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                      })
                    }}
              
                  >
                    {section}
                  </TopMenuElement>
                )
              })}
            </Chapters>
          </TextWidth>
          <ParallaxProvider>
            {Object.entries(Content).map((C, i) => {
              const [category, questions] = C
              return (
                <Chapter
                  key={'chapter_' + i}
                  setCurrent={() => setCurrentSection(i)}
                  colorMode={colorMode}
                  menuentry={category}
                  questions={questions}
                  tenant={tenant as Tenant}
                />
              )
            })}
          </ParallaxProvider>
          <TextWidth>
            <Impressum
              style={{
                backgroundColor:
                  colorMode === 'dark'
                    ? 'rgba(255,255,255,.1)'
                    : 'var(--gray-5)',
                color: colorMode === 'dark' ? 'var(--gray-3)' : 'var(--gray-2)',
              }}
            >
              <div className='row'>
                <div className='label'>Konzept</div>
                <div className='person'>Tina Huber</div>
              </div>
              <div className='row'>
                <div className='label'>Gestaltung, Umsetzung</div>
                <div className='person'>Sebastian Broschinski</div>
              </div>
              <div className='row'>
                <div className='label'>Bilder</div>
                <div className='person'>
                  HBO, Keystone, AP Photo, Getty Images
                </div>
              </div>
            </Impressum>
          </TextWidth>
        </>
      )}
    </AppContainer>
  )
}
const Impressum = styled.div`
  padding: 15px;
  font-size: 15px;
  font-family: var(--font-sans-serif);
  .row {
    line-height: 1.6em;
    display: flex;
  }
  .label {
    flex: 0 0 30%;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.3px;
  }

  .person {
  }
`
const BottomMenu = ({
  current,
  entries,
}: {
  current: number
  entries: string[]
}) => {
  const [isOpen, setopen] = useState(false)
  return (
    <BottomMenuRoot isOpen={isOpen}>
      <MenuButton onClick={() => setopen(!isOpen)} isOpen={isOpen}></MenuButton>

      <MenuContainer onClick={() => setopen(!isOpen)}>
        {Sections.map((section, r) => {
          return (
            <BottomMenuElement
              key={'menuelementmobile_' + r}
              onClick={() => {
                if (isOpen) {
                  trackEvent('chapternav_mob_selected_' + section)

                  let w = window as any
                  w.menucontent[section.toLowerCase()].scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                  })
                }

                setopen(!isOpen)
              }}
              style={{
                fontWeight: current === r ? 'bold' : 'normal',
              }}
            >
              {section}
            </BottomMenuElement>
          )
        })}
      </MenuContainer>
      <ArrowDown isOpen={isOpen} onClick={() => setopen(!isOpen)} />
    </BottomMenuRoot>
  )
}

const TopMenuElement = styled.button<{ left: boolean }>`
  flex: 0 0 calc(50% - 20px);
  text-align: ${({ left }) => (left ? 'right' : 'left')};
  padding: 10px;
  padding-top: 15px;
  padding-bottom: 0px;
  font-weight: 700;
  font-size: 18px;
  border:0;
  background-color: transparent;
  color:var(--text-color);
  &:hover{
    cursor: pointer;
    opacity: .6;
  }
`

const Chapters = styled.div`
margin-top: 30px;
margin-bottom: 60px;
  display: flex;
  
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0px 0px 0px 20px;
  max-width: 300px;
  font-size: 18px;
  margin-left: auto;
  margin-right: auto;
  font-family: var(--font-sans-serif);
  * {
  }
  .title {
    flex: 0 0 100%;
    text-align: center;
  }
`

const MenuContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-direction: row;
  font-size: 15px;
  color: var(--red-main);
  max-width: 100%;
  gap: 5px;
  z-index: 10;
`
const MenuButton = styled.div<{ isOpen: boolean }>`
  position: fixed;
  right: ${({ isOpen }) => (isOpen ? '-60px' : '0px')};
  bottom: 140px;
  width: 60px;
  height: 60px;
  background-color: var(--text-color);
  background-image: url(${menuicon});
  background-size: contain;
  background-repeat: no-repeat;
  transition: right 0.2s ease;
  transition-delay: ${({ isOpen }) => (isOpen ? '0' : '.4s')};
  z-index: 2;
`
const ArrowDown = styled.div<{ isOpen: boolean }>`
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  top: 30px;
  right: calc(50% - 15px);
  border-top: 7px solid var(--site-background);
  transition: transform 0.6s ease;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(0DEG)' : 'rotate(180DEG)')};
`

const BottomMenuElement = styled.div`
  width: calc(100% - 40px);
  color: var(--site-background);
  font-size: 15px;
  letter-spacing: 0.4px;
  padding: 10px 20px;
  padding-left: 30px;
  background-color: var(--text-color);
  text-align: center;
  text-transform: uppercase;

  span {
    font-weight: 300;
  }
`
const BottomMenuRoot = styled.div<{ isOpen: boolean }>`
  font-family: var(--font-sans-serif);
  position: fixed;
  bottom: 0;

  background-color: var(--text-color);
  width: 100%;
  z-index: 900;
  right: 0;
  color: var(--site-background);
  max-height: ${({ isOpen }) => (isOpen ? '100%' : '0px')};
  padding-top: ${({ isOpen }) => (isOpen ? '80px' : '0px')};
  transition: all 0.5s ease-in;
`

const SideMenu = styled.div`
  display: inline-block;
  width: 100%;
  height: 10px;
  position: fixed;
  right: 15px;
  top: 20%;
  z-index: 900;
  width: 200px;
  @media only screen and (min-width: 1200px) {
    right: 100px;
  }
  @media only screen and (max-width: 999px) {
    top: 0;
  }
  .sidecontainer {
    display: inline-block;
    height: 100%;
  }
`

const MenuElement = styled.button`
  border: 0;
  flex: 0 0 calc(50% - 6.5px);
  background-color: transparent;
  font-size: 15px;
  font-family: var(--font-sans-serif);
  color: var(--text-color) !important;
  font-weight: 300;
  width: 100%;
  text-align: right;
  padding: 5px;
  padding-right: 10px;
  border-right: 1px solid var(--text-color);

  cursor: pointer;

  @media only screen and (max-width: 711px) {
    font-size: 18px;
    margin-bottom: 10px;
    padding: 0;
  }
  &:hover {
    opacity: 0.8;
    font-weight: 900;
  }
`

const Header = styled.header`
  width: 100vw;
  max-width: 100%;
  margin-bottom: 30px;
  text-align: center;
  position: relative;
  font-size: 30px;
  line-height: 1.1em;

  h1 {
    margin: 0;
    margin-top: 0px;
    margin-left: auto;
    margin-right: auto;
    /* text-shadow: #fff 0 0 3px; */
    width: calc(100vw - 30px);
    max-width: 700px;
    @media only screen and (max-width: 711px) {
      margin-bottom: 60px;
    }
    img {
      max-width: 60px;
      margin-bottom: 10px;
      margin-left: auto;
      margin-right: auto;
    }
  }
  @media only screen and (max-width: 711px) {
    font-size: 26px;
  }
  div {
    max-width: calc(100vw - 30px);
    line-height: 1em;

    &.big {
      font-weight: 900;
      font-family: 'Suez One', serif;
      &.a {
        margin-bottom: 30px;
        @media only screen and (max-width: 711px) {
          font-size: 36px;
        }
      }
      &.c {
        line-height: 1.4em;

        font-family: var(--font-sans-serif);
        font-weight: 300;
        font-size: 22px;
        @media only screen and (max-width: 711px) {
          font-size: 18px;
        }
      }
    }
  }

  img {
    max-width: 1150px;
    @media only screen and (max-width: 1099px) {
      width: 100%;
      width: 120%;
      margin-left: -10%;
    }
  }
  div {
    display: inline-block;
    max-width: 100%;
    min-height: 100%;
    width: 100%;
    position: relative;
    @media only screen and (max-width: 900px) {
    }
  }
`
const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  background-color: var(--site-background);
  max-width: 100vw;
  overflow: hidden;
`
export default MainComponent
